export const ruleManagerPath = () => '/settings/rule-manager';
